function _createForOfIteratorHelper(o, e) {
  var t,
    r,
    n,
    c,
    l = ("undefined" != typeof Symbol && o[Symbol.iterator]) || o["@@iterator"];
  if (l)
    return (
      (n = !(r = !0)),
      {
        s: function () {
          l = l.call(o);
        },
        n: function () {
          var o = l.next();
          return (r = o.done), o;
        },
        e: function (o) {
          (n = !0), (t = o);
        },
        f: function () {
          try {
            r || null == l.return || l.return();
          } finally {
            if (n) throw t;
          }
        },
      }
    );
  if (
    Array.isArray(o) ||
    (l = _unsupportedIterableToArray(o)) ||
    (e && o && "number" == typeof o.length)
  )
    return (
      l && (o = l),
      (c = 0),
      {
        s: (e = function () {}),
        n: function () {
          return c >= o.length ? { done: !0 } : { done: !1, value: o[c++] };
        },
        e: function (o) {
          throw o;
        },
        f: e,
      }
    );
  throw new TypeError(
    "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(o, e) {
  var t;
  if (o)
    return "string" == typeof o
      ? _arrayLikeToArray(o, e)
      : "Map" ===
          (t =
            "Object" === (t = {}.toString.call(o).slice(8, -1)) && o.constructor
              ? o.constructor.name
              : t) || "Set" === t
      ? Array.from(o)
      : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
      ? _arrayLikeToArray(o, e)
      : void 0;
}
function _arrayLikeToArray(o, e) {
  (null == e || e > o.length) && (e = o.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = o[t];
  return r;
}
document.addEventListener("DOMContentLoaded", function () {
  // Helper function to check if an option name is a color option (locale-aware)
  function isColorOption(optionName) {
    if (!optionName) return false;
    var normalized = optionName.toLowerCase().trim();

    // Check against translated color option name if available
    if (
      window.SHOPIFY_LOCALE_OPTION_NAMES &&
      window.SHOPIFY_LOCALE_OPTION_NAMES.color
    ) {
      var translatedColor =
        window.SHOPIFY_LOCALE_OPTION_NAMES.color.toLowerCase();
      if (
        normalized === translatedColor ||
        normalized.includes(translatedColor)
      ) {
        return true;
      }
    }

    // Fallback to common color-related keywords
    return (
      normalized.includes("color") ||
      normalized.includes("colour") ||
      normalized.includes("farge") ||
      normalized.includes("färg") ||
      normalized.includes("farve") ||
      normalized.includes("kleur") ||
      normalized.includes("väri")
    );
  }

  // Helper function to check if an option name is a size option (locale-aware)
  function isSizeOption(optionName) {
    if (!optionName) return false;
    var normalized = optionName.toLowerCase().trim();

    // Check against translated size option name if available
    if (
      window.SHOPIFY_LOCALE_OPTION_NAMES &&
      window.SHOPIFY_LOCALE_OPTION_NAMES.size
    ) {
      var translatedSize =
        window.SHOPIFY_LOCALE_OPTION_NAMES.size.toLowerCase();
      if (
        normalized === translatedSize ||
        normalized.includes(translatedSize)
      ) {
        return true;
      }
    }

    // Fallback to common size-related keywords
    return (
      normalized.includes("size") ||
      normalized.includes("størrelse") ||
      normalized.includes("storlek") ||
      normalized.includes("koko")
    );
  }

  function r(o) {
    o &&
      (console.log("🖼️ Updating main product image for color:", o),
      setTimeout(function () {
        var o = document.querySelector('[name="id"]');
        if (o && o.value) {
          var e = o.value,
            o =
              (console.log("📦 Current variant ID:", e),
              document.querySelector("[data-product-json]"));
          if (o)
            try {
              var t,
                r,
                n,
                c = JSON.parse(o.textContent).variants.find(function (o) {
                  return o.id.toString() === e.toString();
                });
              c && c.featured_media
                ? ((r =
                    null ==
                      (t = document.querySelector('[id^="MediaGallery-"]')) ||
                    null == (t = t.id)
                      ? void 0
                      : t.replace("MediaGallery-", "")),
                  (n = "".concat(r, "-").concat(c.featured_media.id)),
                  console.log("🎯 Trying to set media ID:", n),
                  window.setActiveMediaSlide && window.setActiveMediaSlide(n)
                    ? console.log("✅ Main product image updated successfully!")
                    : console.log("❌ Failed to update main product image"))
                : console.log("⚠️ No featured media for this variant");
            } catch (o) {
              console.error("❌ Error updating main product image:", o);
            }
          else console.log("❌ No product data found");
        } else console.log("❌ No variant ID found");
      }, 500));
  }
  function c(o, e) {
    var t,
      r = e.dataset.variantImage,
      n = e.dataset.variantImageSrcset,
      e = e.dataset.variantUrl;
    r &&
      "" !== r &&
      ((t = o.querySelector(".card__media img")),
      (o = o.querySelector(".card__heading a")),
      t && ((t.src = r), n) && (t.srcset = n),
      o) &&
      e &&
      (o.href = e);
  }
  function l(i) {
    var gi = n.querySelectorAll(".grid__item");
    var o, s;
    i &&
      (console.log("🔍 Filtering products by color:", i),
      (o =
        n.querySelectorAll(".grid__item[data-product-id]") ||
        n.querySelectorAll(".card-wrapper") ||
        n.querySelectorAll(".grid__item")),
      o = o.length ==0 && gi.length !=0 ? gi : o,
      console.log("📦 NEW Found product cards:", o.length),
      (s = 0),
      o.forEach(function (o) {
        var e,
          t,
          r,
          n,
          c = o.querySelectorAll(".color-swatch"),
          l = !1,
          a = null;
        c.forEach(function (o) {
          var e = o.getAttribute("title");
          e && e.toLowerCase() === i.toLowerCase()
            ? ((l = !0), (a = o).classList.add("active"))
            : o.classList.remove("active");
        }),
          l
            ? (o.classList.remove("hidden"),
              s++,
              a &&
                ((c = o),
                (t = (n = a).dataset.variantImage),
                (r = n.dataset.variantImageSrcset),
                (n = n.dataset.variantUrl),
                t && "" !== t
                  ? ((e = c.querySelector(".card__media img")),
                    (c = c.querySelector(
                      ".card__content-link, .card__heading a"
                    )),
                    e &&
                      ((e.src = t),
                      r && (e.srcset = r),
                      console.log("✅ Updated product image:", t)),
                    c &&
                      n &&
                      ((c.href = n),
                      console.log("✅ Updated product link:", n)))
                  : console.log("⚠️ No variant image found for swatch")))
            : o.classList.add("hidden");
      }),
      0 === s
        ? ((e.style.display = "block"),
          console.log("❌ No products found in color:", i))
        : ((e.style.display = "none"),
          console.log("✅ Found ".concat(s, " products in color:"), i)),
      console.log(
        "Filtered products: "
          .concat(s, " visible out of ")
          .concat(o.length, " total")
      ));
  }
  function a(o) {
    if (window.COLOR_METAOBJECTS && o) {
      var e,
        t = window.COLOR_METAOBJECTS.normLabel(o),
        r =
          (console.log("🔍 Searching for color:", {
            colorName: o,
            normalizedColor: t,
          }),
          window.COLOR_METAOBJECTS.byLabel[t]);
      if (r && r.id)
        return (
          (e = "gid://shopify/Metaobject/".concat(r.id)),
          console.log("✅ Found metaobject:", { metaobject: r, gid: e }),
          e
        );
      var n,
        c = _createForOfIteratorHelper(window.COLOR_METAOBJECTS.list);
      try {
        for (c.s(); !(n = c.n()).done; ) {
          var l,
            a = n.value;
          if (a && a.label && window.COLOR_METAOBJECTS.normLabel(a.label) === t)
            return (
              (l = "gid://shopify/Metaobject/".concat(a.id)),
              console.log("✅ Found metaobject in list:", { item: a, gid: l }),
              l
            );
        }
      } catch (o) {
        c.e(o);
      } finally {
        c.f();
      }
      console.log("❌ No metaobject found for color:", o);
    } else console.log("❌ COLOR_METAOBJECTS not available or no color name provided");
    return null;
  }
  var e, o, t, n, i, s, u, d, g;
  console.log("🚀 Product page scripts loaded"),
    (window.ProductColorTracker = {
      currentColor: "",
      currentColorOption: "",
      callbacks: [],
      isInitialized: !1,
      setCurrentColor: function (e, t) {
        (this.currentColor = e),
          (this.currentColorOption = t),
          console.log("🎨 Active product color changed:", {
            color: e,
            option: t,
            timestamp: new Date().toISOString(),
          }),
          this.updateAllSections(),
          this.callbacks.forEach(function (o) {
            try {
              o(e, t);
            } catch (o) {
              console.error("Error in color change callback:", o);
            }
          });
      },
      getCurrentColor: function () {
        return this.currentColor;
      },
      getCurrentColorOption: function () {
        return this.currentColorOption;
      },
      onColorChange: function (o) {
        "function" == typeof o
          ? this.callbacks.push(o)
          : console.warn(
              "ProductColorTracker.onColorChange: callback must be a function"
            );
      },
      updateAllSections: function () {
        var e = this,
          o = document.querySelectorAll("[data-current-color]"),
          o =
            (0 < o.length &&
              o.forEach(function (o) {
                o &&
                  o.setAttribute &&
                  o.setAttribute(
                    "data-current-color",
                    e.currentColor.toLowerCase()
                  );
              }),
            document.querySelectorAll("[data-current-color-option]")),
          o =
            (0 < o.length &&
              o.forEach(function (o) {
                o &&
                  o.setAttribute &&
                  o.setAttribute(
                    "data-current-color-option",
                    e.currentColorOption
                  );
              }),
            document.querySelectorAll(".current-color-indicator"));
        0 < o.length &&
          o.forEach(function (o) {
            o &&
              void 0 !== o.textContent &&
              (o.textContent = e.currentColor ? " - " + e.currentColor : "");
          });
      },
    }),
    console.log("🎯 Initializing more this color filtering..."),
    (n =
      document.querySelector(".featured-collection-wrap .enable_custom_swipe") ||
      document.querySelector(".custom-more-this-color") ||
      document.querySelector(".more-this-color") ||
      document.querySelector('[data-section-type="more-this-color"]'))
      ? (console.log("✅ Found more this color section"),
        (e = n.querySelector(".no-colors-message")) ||
          (((t = document.createElement("div")).className =
            "no-colors-message"),
          (t.style.cssText =
            "\n        text-align: center;\n        padding: 2rem;\n        color: #666;\n        font-size: 1.1rem;\n        background: #f8f8f8;\n        border-radius: 8px;\n        margin: 1rem 0;\n        display: none;\n      "),
          (t.textContent = "Ingen produkter i denne fargen"),
          (o = n.querySelector(".grid")) && o.parentNode.insertBefore(t, o),
          (e = t)),
        window.ProductColorTracker.onColorChange(function (o, e) {
          console.log("🎨 Color changed in more this color section:", o);
          var fwrap = document.querySelector('.featured-collection-parent-wrap');
          if (fwrap){
            var ttitle = fwrap.querySelector('.title');
            var baseTitle = ttitle.dataset.baseTitle;
            if (ttitle && baseTitle) {
              ttitle.textContent = baseTitle + ' ' + o;
            }
          }

          var t,
            r =
            document.querySelector(".featured-collection-wrap .enable_custom_swipe") ||
              document.querySelector(".custom-more-this-color") ||
              document.querySelector(".more-this-color") ||
              document.querySelector('[data-section-type="more-this-color"]'),

            n = a(o),
            e =
              (r.setAttribute("data-current-color", o.toLowerCase()),
              r.setAttribute("data-current-color-option", e),
              n &&
                (r.setAttribute("data-current-color-metaobject-gid", n),
                console.log(
                  "✅ Updated data-current-color-metaobject-gid:",
                  n
                )),
              r.querySelector(".current-color-indicator")),
            e =
              (e && (e.textContent = o ? " - " + o : ""),
              r.querySelector("h2.title")),
            e =
              (e &&
                ((t = e.getAttribute("data-base-title") || "MORE IN THIS"),
                o && "" !== o.trim()
                  ? (e.textContent = t + " " + o)
                  : (e.textContent = t + " COLOR")),
              r.querySelector(".collection__view-all a"));
          e &&
            (o && "" !== o.trim()
              ? n
                ? ((t = "/collections/alle?filter.v.t.shopify.color-pattern="
                    .concat(encodeURIComponent(n), "&color=")
                    .concat(encodeURIComponent(o))),
                  (e.href = t),
                  console.log("✅ Updated viewAllLink with metaobject GID:", t))
                : ((n = "/collections/all?filter.v.option.color="
                    .concat(encodeURIComponent(o), "&color=")
                    .concat(encodeURIComponent(o))),
                  (e.href = n),
                  console.log("⚠️ Using fallback href (no GID):", n))
              : ((t =
                  r.getAttribute("data-collection-url") || "/collections/all"),
                (e.href = t),
                console.log("📋 Using collection URL:", t))),
            l(o),
            console.log("More in this color section updated with color:", o);
        }),
        (o = window.ProductColorTracker.getCurrentColor()) &&
          ((t =
            document.querySelector(".featured-collection-wrap .enable_custom_swipe") ||
            document.querySelector(".custom-more-this-color") ||
            document.querySelector(".more-this-color") ||
            document.querySelector('[data-section-type="more-this-color"]')),
          (u = a(o)),
          t.setAttribute("data-current-color", o.toLowerCase()),
          u &&
            (t.setAttribute("data-current-color-metaobject-gid", u),
            console.log(
              "✅ Updated initial data-current-color-metaobject-gid:",
              u
            )),
          (s = t.querySelector(".current-color-indicator")) &&
            (s.textContent = " - " + o),
          (s = t.querySelector("h2.title")) &&
            ((i = s.getAttribute("data-base-title") || "MORE IN THIS"),
            (s.textContent = i + " " + o)),
          (s = t.querySelector(".collection__view-all a")) &&
            o &&
            (u
              ? ((i = "/collections/alle?filter.v.t.shopify.color-pattern="
                  .concat(encodeURIComponent(u), "&color=")
                  .concat(encodeURIComponent(o))),
                (s.href = i),
                console.log(
                  "✅ Updated initial viewAllLink with metaobject GID:",
                  i
                ))
              : ((u = "/collections/all?filter.v.option.color="
                  .concat(encodeURIComponent(o), "&color=")
                  .concat(encodeURIComponent(o))),
                (s.href = u),
                console.log("⚠️ Using initial fallback href (no GID):", u))),
          l(o)))
      : console.log("⚠️ More this color section not found"),
    console.log("🎨 Initializing upsells color synchronization..."),
    window.ProductColorTracker.onColorChange(function (n, o) {
      console.log("🔄 Main product color changed, syncing upsells:", n);
      var e = document.querySelector(".product__upsells");
      e
        ? ((e = e.querySelectorAll(".product__upsells-item")),
          console.log("📦 Found upsell cards:", e.length),
          e.forEach(function (o, e) {
            console.log("🔄 Processing upsell card ".concat(e + 1));
            var t = o.querySelectorAll('.swatch-input__input[type="radio"]'),
              r =
                (console.log(
                  "🎨 Found color swatches in card ".concat(e + 1, ":"),
                  t.length
                ),
                null);
            t.forEach(function (o) {
              var e = o.value.toLowerCase();
              e === n.toLowerCase() &&
                ((r = o),
                console.log("✅ Found matching color swatch: ".concat(e)));
            }),
              r
                ? ((r.checked = !0),
                  r.dispatchEvent(new Event("change", { bubbles: !0 })),
                  (t = o.querySelector('label[for="'.concat(r.id, '"]'))) &&
                    (o
                      .querySelectorAll(".swatch-input__label")
                      .forEach(function (o) {
                          o.closest(".color-swatch")?.classList.remove("active");
                        return o.classList.remove("active");
                      }),
                      t.closest(".color-swatch")?.classList.add("active"),
                    t.classList.add("active")),
                  c(o, r),
                  console.log(
                    "✅ Updated color in upsell card "
                      .concat(e + 1, " to: ")
                      .concat(n)
                  ))
                : console.log(
                    "⚠️ No matching color found in upsell card "
                      .concat(e + 1, " for color: ")
                      .concat(n)
                  );
          }))
        : console.log("⚠️ Upsells section not found");
    }),
    console.log("✅ Upsells color synchronization initialized"),
    console.log("🖼️ Initializing upsells image switching..."),
    document.querySelectorAll(".product__upsells-item").forEach(function (o) {
      var e = o.querySelector(".swatch-input__input:checked");
      e && c(o, e);
    }),
    document.addEventListener("click", function (o) {
      o.target.classList.contains("swatch-input__input") &&
        o.target.closest(".product__upsells-item") &&
        c(o.target.closest(".product__upsells-item"), o.target);
    }),
    window.ProductColorTracker.isInitialized
      ? console.log("⚠️ Color tracker already initialized, skipping...")
      : (console.log("🔍 Initializing color tracker..."),
        (s = i = ""),
        (u = document.querySelector("[data-current-color]")) &&
          ((i = u.getAttribute("data-current-color")),
          (s = u.getAttribute("data-current-color-option"))),
        i ||
          ((u = document.querySelector(
            'variant-selects input[type="radio"]:checked'
          )) &&
            ((d = (
              u.name ? u.name.replace("options[", "").replace("]", "") : ""
            )
              .replace(/\n/g, "")
              .trim()),
            isColorOption(d)) &&
            ((i = u.value.toLowerCase()), (s = d))),
        console.log("📋 Initial color found:", { color: i, option: s }),
        i
          ? (window.ProductColorTracker.setCurrentColor(i, s || ""), r(i))
          : console.log("⚠️ No initial color found"),
        document.addEventListener("change", function (o) {
          var e, t;
          "radio" === o.target.type &&
            o.target.closest("variant-selects") &&
            o.target.name &&
            (console.log("🔄 Delegated change event caught:", o.target),
            (e = o.target.value),
            (t = o.target.name
              .replace("options[", "")
              .replace("]", "")
              .replace(/\n/g, "")
              .trim()),
            console.log("📝 Delegated change values:", {
              value: e,
              option: t,
              name: o.target.name,
            }),
            isColorOption(t)) &&
            (console.log("✅ Delegated color change detected:", e),
            window.ProductColorTracker.setCurrentColor(e.toLowerCase(), t),
            r(e.toLowerCase()));
        }),
        document.addEventListener("optionValueSelectionChange", function (o) {
          var e, t;
          console.log("🔄 optionValueSelectionChange event fired:", o.detail),
            o.detail &&
              o.detail.data &&
              (o = o.detail.data.target) &&
              (console.log("🎯 Target element:", o),
              (e =
                o.closest("fieldset") || o.closest(".product-form__input"))) &&
              (e = e.querySelector("legend")) &&
              e.textContent &&
              ((t = e.textContent.toLowerCase()),
              console.log("🏷️ Legend text:", t),
              isColorOption(t)) &&
              (t = o.value || o.textContent) &&
              ((o = e.textContent.split(":")[0].trim()),
              console.log("✅ Custom event color option detected:", {
                value: t,
                option: o,
              }),
              window.ProductColorTracker.setCurrentColor(t.toLowerCase(), o),
              r(t.toLowerCase()));
        }),
        (window.ProductColorTracker.isInitialized = !0)),
    document
      .querySelectorAll(".product-form__input--dropdown")
      .forEach(function (o) {
        var e,
          t = o.querySelector("select");
        t &&
          (e = o.querySelector(".show-all-variants")) &&
          (e.addEventListener("click", function () {
            (t.size = t.options.length),
              (t.style.height = "auto"),
              (e.style.display = "none");
          }),
          t.addEventListener("blur", function () {
            (t.size = 1), (t.style.height = ""), (e.style.display = "block");
          }));
      }),
    (g = document.querySelector(".rating-wrapper"))
      ? (g.addEventListener("click", function (o) {
          o.preventDefault();
          o = document.querySelector(".loox-widget");
          o &&
            (o.scrollIntoView({ behavior: "smooth", block: "start" }),
            console.log("✅ Scrolled to reviews section"));
        }),
        (g.style.cursor = "pointer"))
      : console.log("⚠️ Rating wrapper not found");
});
